<template>
  <div id="app">
    <el-container>
      <!-- 顶部导航栏 -->
<!--        background-color: rebeccapurple;-->
<!--      style="background-color:#663399 "-->
<!--      background-image: linear-gradient(to right, #FF0000,#FFF200, #1E9600);-->
      <div style="height: 20%" >
        <el-header  class="nav" style="background-image: linear-gradient(to right, #118182,#4ACBB6);height: 90px" >
          <div class="container" style="width: 1140px;  height: 100%; margin: 0 auto;">
            <router-link  class="logo" to="/home" style="vertical-align:middle;float: left">
              <span style="font-size: 48px; vertical-align:middle;margin-top: 15px;float: left;font-family:Noto Sans SC;font-weight: 500">PGMG Server</span>
            </router-link>

            <el-menu
                    class="el-menu-demo"
                    mode="horizontal"
                    :router="true"
                    @select="handleSelect"
                    text-color="#fff"
                    :default-active="$router.currentRoute.path"
                    active-text-color="#ffde7d"

                    style="background-color: transparent; ">
              <el-menu-item index="/home" class="item" style="font-size: 25px;margin-top: 30px">Home</el-menu-item>
                <el-menu-item index="/submit" class="item" style="font-size: 25px;margin-top: 30px">Submit</el-menu-item>
<!--                <el-menu-item index="/check" class="item">Check</el-menu-item>-->
                <el-menu-item index="/result" class="item"  style="font-size: 25px;margin-top: 30px">Result</el-menu-item>
              <el-menu-item class="item" index="/ev" style="font-size: 25px;margin-top: 30px">Experiment Validation</el-menu-item>
              <el-menu-item class="item" index="/tutorial" style="font-size: 25px;margin-top: 30px">Tutorial</el-menu-item>
<!--              <el-menu-item class="item" index="/contact" style="font-size: 28px;margin-top: 30px">Contact Us</el-menu-item>-->
            </el-menu>
          </div>
        </el-header>
      </div>

      <!-- 路由页面 -->
      <el-main
              style="min-height:80vh;background-color: RGB(244,246,249)"
              class="main"
      >
        <router-view></router-view>
      </el-main>
      <!-- 底部版权页 -->
      <el-footer style="height:10vh;background-color: #363636; height: 160px" >
        <el-link style="font-size: 20px;float: left;margin-right: 20px;color:RGB(240,248,255);" href="https://github.com/CSUBioGroup/PGMG">
          Github
        </el-link>

        <el-link  style="font-size: 20px;float: left;margin-right: 20px;color:RGB(240,248,255);" href="https://arxiv.org/abs/2207.00821">
          Paper
        </el-link>

        <el-link  style="font-size: 20px;float: left;color:RGB(240,248,255);" href="https://www.csuligroup.com/PGMG/#/contact">
          Contact Us
        </el-link>
        <br>
          <p style="font-size:15px;color:RGB(240,248,255);margin-top: 25px">
            <span style="font-size: 18px">
              If you found PGMG useful, please consider citing our paper:
              <br>
<!--              <i>Zhu H, Zhou R, Tang J, Li M. PGMG: A Pharmacophore-Guided Deep Learning Approach for Bioactive-->
<!--              Molecular Generation[J].arXiv preprint arXiv:2207.00821</i>, 2022.-->
              Zhu, H., Zhou, R., Cao, D., Tang, J., & Li, M. (2023). A pharmacophore-guided deep learning
              approach for bioactive molecular generation. Nature Communications, 14(1), 6234.
            </span>
            <br>
<!--            <br>-->
<!--            <span style="font-size: 13px">-->
<!--            reference:-->
<!--            <br>-->
<!--          1. Wermuth C-G, Ganellin CR, Lindberg P, Mitscher LA. Glossary of terms used in medicinal chemistry-->
<!--              (IUPAC Recommendations 1997). <i>Annual reports in medicinal chemistry 33</i>, 385-395 (1998).-->
<!--            <br>-->
<!--            2. Zhu H, Zhou R, Tang J, Li M. PGMG: A Pharmacophore-Guided Deep Learning Approach for-->
<!--              Bioactive Molecular Generation[J]. <i>arXiv preprint arXiv:2207.00821</i>, 2022.-->
<!--              </span>-->
          </p>
        <p class="copyright">Copyright © 2023 CSU Bioinformatics Group. All rights reserved.</p>
      </el-footer>
    </el-container>
  </div>




</template>
<script>


export default {
  name: 'app',
  components: {},
  data() {
    return {
      activeIndex: '/home',
      logo:'https://www.csuligroup.com/DrugGen/img/logo1_small.png',
    }
  },
  methods: {
    handleSelect() {

    }
  }
}
</script>

<style scoped>
  .main{
    /*height: 80vh;*/
  }
#app {
  /*background-color: #5daf34;*/
  height: 100vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  font-size: 1.1rem;
  color: #2c3e50;
}
body{
  min-width: 1250px;
}
span,.item,el-link{

  font-family: "Noto Sans SC";
}
::v-deep.el-menu {}
  .el-menu-item:hover,
  .el-menu-item:focus {
    background-color: red;
    /*background-image: url("../../../assets/img/menu_bg.png");*/
    background-position: center;
  /*// linear-gradient(*/
  /*//   to bottom right,*/
  /*//   #6691ff,*/
  /*//   #6269fc,*/
  /*//   #6269fc*/
  /*// );*/
  }

.el-menu-item.is-active {
  background-color: transparent!important;
}
.el-menu-item:hover{
  background-color:transparent !important;
  color:#ff7500 !important;
}
/*.el-submenu__title:hover {*/
/*  background-color: #ffff00 !important;*/
/*}*/
.el-menu-item:hover,
.el-menu-item:focus {
  background-color: red;
  /*background-image: url("../../../assets/img/menu_bg.png");*/
  /*background-position: center;*/
/*// linear-gradient(*/
/*//   to bottom right,*/
/*//   #6691ff,*/
/*//   #6269fc,*/
/*//   #6269fc*/
/*// );*/
}


.subitem {
  font-size: 17px;
}

.item {
  font-size: 20px;
}

.copyright {
  padding-top:3px;
  color: aliceblue;
  font-size: 22px;
  text-align: center;
  margin: 0 auto;
}

.el-menu-demo {
  float: right;
}

.logo {
  text-decoration: none;
  color: rgba(255, 255, 255, .8);
  display: flex;
  float: left;
}

.logo span {
  line-height: 60px;
}

.logo .icon {
  margin-top: 10px;
  margin-right: 15px;
  width: 40px;
  height: 40px;
}
</style>
